import React from 'react';
import { forwardRef } from 'react';
import styled from 'styled-components';
import { Props, ZTooltip } from '../ztooltip';

export interface IconProps {
    tooltip?: React.ReactNode;
    className?: string;
    disabled?: boolean;
    children?: React.ReactNode;
    onClick?: (e: React.MouseEvent<HTMLDivElement>) => void;
}

export const _Icon = forwardRef<HTMLDivElement, IconProps & Omit<Props, 'html'> & React.HTMLAttributes<HTMLDivElement>>(
    ({ tooltip, className, children, onClick, interactive, position, ...rest }, ref) => {
        return (
            <div ref={ref} onClick={onClick} className={className} {...rest}>
                {/* If tooltip apply the tooltip container */}
                {tooltip &&
                    (typeof tooltip === 'string' ? (
                        <ZTooltip addContainer title={tooltip} interactive={interactive} position={position}>
                            {children}
                        </ZTooltip>
                    ) : (
                        <ZTooltip html={<>{tooltip}</>} addContainer interactive={interactive ?? true} position={position}>
                            {children}
                        </ZTooltip>
                    ))}
                {/* If no tooltip, just render children SVG */}
                {!tooltip && children}
            </div>
        );
    }
);

export const Icon = styled(_Icon)<{ $hoverable?: boolean }>`
    width: 16px;
    height: 16px;
    min-width: 16px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    transition: color 0.2s ease-in;

    svg {
        width: 16px;
        height: 16px;
        fill: currentColor;
        stroke: inherit;
        stroke-width: inherit;
        display: block;
        flex-shrink: 0;
    }

    ${(props) =>
        props.$hoverable &&
        !props.disabled &&
        `
		&:hover {
			cursor: pointer;
			opacity: 0.7;
		}
	`}

    ${(props) => props.disabled && `opacity: 0.5;`}
`;
